import UnwrappedFormatInfo from '@bibliocommons/shared-format-info';
import injectLibrary from 'app/components/hocs/injectLibrary';

const mapLibraryToProps = ({ library }, ownProps) => ({
  showEdition:
    !library.get('onlyShowEditionsForCDROMAndVideoGames') ||
    ['CDROM', 'VIDEO_GAME'].includes(ownProps.item.getIn(['briefInfo', 'format'])),
  showCallNumber:
    typeof ownProps.showCallNumber !== 'undefined'
      ? ownProps.showCallNumber
      : library.get('showCallNumber') &&
        (library.get('showCallNumberForDigital') || ownProps.item.getIn(['policy', 'materialType']) === 'PHYSICAL') &&
        (!library.get('hideCallNumberForHigherSearchScope') || ownProps.searchScopeIsCurrent)
});

export default injectLibrary(mapLibraryToProps)(UnwrappedFormatInfo);
